import { render, staticRenderFns } from "./task-board.vue?vue&type=template&id=0a083c96&"
import script from "./task-board.vue?vue&type=script&lang=js&"
export * from "./task-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports